type Params = {
  mediaFilters:
    | {
        id?: number;
        name: string;
        url: string;
      }[]
    | null
    | undefined;
  filterName: string | string[];
};

export default function getMediaFilterUrl({
  mediaFilters,
  filterName,
}: Params) {
  if (mediaFilters) {
    const names = Array.isArray(filterName) ? filterName : [filterName];
    for (const name of names) {
      const filter = mediaFilters.find(({ name: n }) => n === name);
      if (filter?.url) return filter.url;
    }
  }
}

export type FilterableMedia = {
  id?: number;
  path?: string | null;
  filename?: string | null;
  mediaFilters?: Params['mediaFilters'];
};

/**
 * Url of an existing filter, else the thumb url the filter will have once it is
 * created. Server safe: JSON-LD and <noscript> fallbacks cannot create the
 * filter, MediaFilterImage on the client does, and later renders pick it up.
 */
export function getMediaFilterSrc({
  media,
  filterName,
}: {
  media: FilterableMedia | null | undefined;
  filterName: string | string[];
}) {
  const existingUrl = getMediaFilterUrl({
    mediaFilters: media?.mediaFilters,
    filterName,
  });
  if (existingUrl) return existingUrl;

  const guess = Array.isArray(filterName) ? filterName[0] : filterName;
  if (!media?.path || !media.filename) return undefined;

  return `${process.env.NEXT_PUBLIC_S3_URI}/thumbs/${guess}/${media.path}${media.filename}`;
}
